const Languages = [
	{
		"id": 0,
		"name": "Choose a Language",
		"code": "en"
	},
	{
		"id": 1,
		"name": "English",
		"code": "en"
	},
	{
		"id": 3,
		"name": "Português",
		"code": "br"
	},
	{
		"id": 5,
		"name": "Deutsch",
		"code": "de"
	},
	{
		"id": 6,
		"name": "Español",
		"code": "es"
	},
	{
		"id": 11,
		"name": "日本語",
		"code": "jp"
	},
	{
		"id": 12,
		"name": "한국어",
		"code": "kr"
	}
];

export { Languages };
